import { atom } from 'recoil';

export const activeRequestsAtom = atom({
  key: 'activeRequestsAtom',
  default: 0,
});
